import {isEqual} from 'lodash'
import {useRef, useEffect} from 'hooks'

function deepCompareEquals(a: any, b: any){
  return isEqual(a, b)
}

function useDeepCompareMemoize(value: any) {
  const ref = useRef<any>(undefined)
  // it can be done by using useMemo as well
  // but useRef is rather cleaner and easier

  if (!deepCompareEquals(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}

export function useDeepCompareEffect(callback: any, dependencies: any[]) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, dependencies.map(useDeepCompareMemoize))
}
